import { IconComponent } from '~harmony/components'

import IconSVG from '../../assets/icons/Library.svg'

export const IconLibrary = IconSVG as IconComponent
